<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_5"></a>
<p class="dedi">FOR MY FRIENDS</p>
<p class="dedi1">‘Come, come. Did we not all start out with more important matters on our minds?’</p>
<p class="right"><i>A man I think I overheard in a bar.</i></p>
<a id="page_6"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Dedication01.vue?450b2bb6